import { BookmarkBorderOutlined, HubOutlined } from "@mui/icons-material";
import { Stack, styled } from "@mui/material";
import { useMemo } from "react";
import { useSession, useSettings } from "../../hooks";
import { useGetTeams } from "../../http";
import { SideMenuTeamList } from "./SideMenuTeamList";

const ScrollBox = styled(Stack)`
  overscroll-behavior: contain;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 50px;
`;

const SideMenuTeamsList = () => {
  const { userId } = useSession();
  const { isLoading, data: teams } = useGetTeams(userId);
  const { sideMenuSettings } = useSettings();

  const myTeams = useMemo(() => (teams ? teams.filter((x) => x.isMember) : []), [teams]);
  const followedTeams = useMemo(() => (teams ? teams.filter((x) => !x.isMember && x.isFollowing) : []), [teams]);

  return (
    <ScrollBox spacing={0.5} sx={{ pr: sideMenuSettings.isExpanded ? "0" : "5px" }}>
      <SideMenuTeamList
        isLoading={isLoading}
        icon={
          <HubOutlined
            style={{
              height: 24,
              width: 24,
              margin: "8px",
            }}
          />
        }
        title="My Teams"
        teams={myTeams}
      />
      <SideMenuTeamList
        isLoading={isLoading}
        icon={
          <BookmarkBorderOutlined
            style={{
              height: 24,
              width: 24,
              margin: "8px",
            }}
          />
        }
        title="Following"
        teams={followedTeams}
      />
    </ScrollBox>
  );
};

export { SideMenuTeamsList };
